<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.PaiementSuccess', 2) }}
                    </h3>
                </div>
            </div>

            <div class="">
                <div class="row justify-content-center">

                    <div class="col-lg-5 col-md-7">
                        <div class="card bg-secondary shadow border-0">
                            <div class="px-lg-5 py-lg-5">
                                <div class="text-center text-muted mb-4">

                                </div>
                                <div class="row justify-content-center">

                                    <div class="success">
                                        <h2>{{ $t('message.PaiementSuccess') }}: </h2>
                                    </div>
                            
                                </div>
                                
                                <ul class="mt-3">
                                    <li class="mt-3">Ajoutez vos affiliés en cliquant sur le bouton <strong>Ajouter un patient</strong></li>
                                    <li class="mt-3">Consultez vos affiliés en cliquant sur le bouton <strong>Mes affiliés</strong></li>
                                </ul>
                                
                                <div class="row text-center mt-3">
                                    <div class="col-12">
                                        <b-button  variant="primary" @click="addAffiliate" >
                                            {{ $t('message.addPatient') }}
                                        </b-button>
                                    </div>
                                    <div class="col-12 mt-2">
                                        <b-button variant="info" @click="mesAffiliate" >
                                            {{ $t('message.mesAffilie') }}
                                        </b-button>
                                    </div>
                                    <!-- <div class="card-title ml-3 mt-3">
                                        <b-button variant="primary" @click="addAffiliate" >
                                            {{ $t('message.addPatient') }}
                                        </b-button>
                                        <b-button variant="info" @click="mesAffiliate" >
                                            {{ $t('message.mesAffilie') }}
                                        </b-button>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {
    mapGetters
} from "vuex";
import AppConfig from "../../constants/AppConfig";
export default {
    name: 'landing',

    data() {
        return {
            isLoading: true,
            opacity: 1,
            canCancel: false,
            fullPage: false,
        };
    },
    methods: {
            addAffiliate(){
                 this.$router.push({ name: 'SouscripteurDashboard'});
            },
            mesAffiliate(){
                 this.$router.push({ name: 'mesAffilies'});
            },
    getOffres() {

      fetch(AppConfig.apiUrl + "/paiement/stripe-paiement-success/"+this.$route.params.identifiant, {
        method: "GET",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
        //  console.log("result: "+result);
        })
        .catch(function (error) {
          console.log("Error: "+error);
        });
    },

    },
    mounted() {
      this.setStatus();
    }
}
</script>
<!-- End Facebook Pixel Code -->
<style scoped>

</style>
